import * as React from "react";
import { Box, Container, Typography, Grid, Card, Chip, Stack } from "@mui/material";
import PolicyIcon from "@mui/icons-material/Policy";
import ReplayIcon from "@mui/icons-material/Replay";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";

const policySections = [
  {
    icon: <ReplayIcon sx={{ color: "#1565C0" }} />,
    title: "Return Policy",
    intro:
      "We aim to keep ticketing straightforward while giving passengers a clear understanding of what happens if plans change.",
    points: [
      "Payments made are non-refundable, but the paid amount can be used as a credit for a future booking within 2 weeks of the original travel date.",
      "Passengers may request booking changes up to 12 hours before departure, subject to seat availability.",
      "In unusual operating situations such as severe weather or technical issues, Vishmitha Highway Express may adjust or cancel a booking and will notify affected passengers with an alternative arrangement where possible.",
    ],
  },
  {
    icon: <ShieldOutlinedIcon sx={{ color: "#1565C0" }} />,
    title: "Privacy Policy",
    intro:
      "Customer data is collected only to support booking, travel coordination, and service improvements.",
    points: [
      "We collect personal details such as passenger name, contact number, and payment-related information during the booking process.",
      "Personal information is protected through appropriate safeguards and used only for operational and customer-service purposes.",
      "Information is not sold to outside parties. Limited sharing may occur only with services directly involved in processing the booking or communication workflow.",
      "Cookies and analytics may be used to improve site usability and understand customer behavior.",
    ],
  },
  {
    icon: <GavelOutlinedIcon sx={{ color: "#1565C0" }} />,
    title: "Terms and Conditions",
    intro:
      "Using the booking platform means you agree to the following service conditions.",
    points: [
      "Service availability depends on the operating schedule and route conditions for the Badulla to Colombo service.",
      "A booking is confirmed only after successful processing and availability confirmation.",
      "Passengers are responsible for carrying valid identification and arriving at the boarding point at least 15 minutes before departure.",
      "The company is not responsible for losses caused by missed departures, external delays, or passenger-provided booking mistakes.",
      "Payment-related issues should be reported within 48 hours of the booking transaction.",
    ],
  },
];

export default function Policy() {
  return (
    <Box id="policy" sx={{ bgcolor: "#F4F7FB", pt: 10, pb: 10 }}>
      <Box
        sx={{
          background: "linear-gradient(150deg, #0D1B2A 0%, #1565C0 60%, #0288D1 100%)",
          px: 2,
          py: { xs: 7, md: 9 },
        }}
      >
        <Container maxWidth="lg">
          <Chip
            icon={<PolicyIcon sx={{ color: "inherit !important" }} />}
            label="Privacy, returns, and travel terms"
            sx={{ mb: 2, bgcolor: "rgba(255,255,255,0.14)", color: "white", fontWeight: 700 }}
          />
          <Typography variant="h2" sx={{ color: "white", fontWeight: 900, fontSize: { xs: "2.2rem", md: "3.4rem" }, lineHeight: 1.05, mb: 2, maxWidth: 900 }}>
            Clear policies that customers can scan quickly and understand easily.
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.75)", maxWidth: 760, lineHeight: 1.8 }}>
            This page is now structured around the questions passengers usually have: refunds, privacy, and the rules that apply to each trip.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mt: { xs: -4, md: -6 }, position: "relative", zIndex: 1 }}>
        <Grid container spacing={2.5}>
          {policySections.map((section) => (
            <Grid item xs={12} key={section.title}>
              <Card sx={{ borderRadius: 4, p: { xs: 3, md: 4 }, border: "1px solid rgba(0,0,0,0.06)", boxShadow: "0 16px 36px rgba(13,27,42,0.08)" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ width: 56, height: 56, borderRadius: "50%", display: "grid", placeItems: "center", bgcolor: "#E3F2FD", mb: 2 }}>
                      {section.icon}
                    </Box>
                    <Typography variant="h5" sx={{ fontWeight: 900, color: "#0D1B2A", mb: 1.5 }}>
                      {section.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.85 }}>
                      {section.intro}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Stack spacing={1.5}>
                      {section.points.map((point) => (
                        <Box key={point} sx={{ p: 2, borderRadius: 2.5, bgcolor: "#F8FAFF", border: "1px solid rgba(21,101,192,0.08)" }}>
                          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                            {point}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
